module.exports = __webpack_public_path__ + "static/media/without_4_cards_and_100.92979a30.svg";